const categoriasConEmoji = {
  "Servicios": "💡",
  "Plataformas": "📺",
  "Comida": "🍔",
  "Despensa": "🛒",
  "Gas": "🛢️",
  "Luz": "🔌",
  "Agua": "🚿",
  "Transporte": "🚌",
  "Otros": "💼"
};

export default categoriasConEmoji;


export function obtenerMesActual() {
  const hoy = new Date();
  return `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, "0")}`;
}